import { TooltipWrapper } from '@/ui/TooltipWrapper';
import { Chat } from '@phosphor-icons/react';
import classNames from 'classnames';
import { forwardRef } from 'react';
import * as styles from '../PostActions.css';

type CommentData = {
  commentsCount?: number;
};

type CommentButtonProps = {
  data: CommentData;
  onClick?: () => void;
};

const CommentButton = forwardRef<HTMLButtonElement, CommentButtonProps>(({ data, onClick, ...props }, ref) => {
  return (
    <button
      ref={ref}
      type="button"
      onClick={onClick}
      className={classNames('flex justify-center', styles.button)}
      {...props}
    >
      <Chat size="20" />
      {data?.commentsCount || ''}
    </button>
  );
});

CommentButton.displayName = 'CommentActionButton';

interface CommentActionWithTooltipProps extends CommentButtonProps {
  translations?: Record<string, string>;
}

export const CommentActionButton = ({ onClick, translations, ...props }: CommentActionWithTooltipProps) => {
  if (translations?.['search.pagination.comment']) {
    return (
      <TooltipWrapper portalId="post-actions-container" tooltipText={translations['search.pagination.comment']}>
        <CommentButton onClick={onClick} {...props} />
      </TooltipWrapper>
    );
  }

  return <CommentButton onClick={onClick} {...props} />;
};
